import React from "react";
import AppRouter from "../../AppRouter";

const AppMain = () => {
    return <AppRouter />;
};

export default AppMain;
